// extracted by mini-css-extract-plugin
module.exports =  {"root":"_0d624b9a27--root--jIKH9","logo":"_0d624b9a27--logo--JESqb","name":"_0d624b9a27--name--TtE6j","tags":"_0d624b9a27--tags--FFIf4","tag":"_0d624b9a27--tag--U0Kwp"};